import Pagination from 'react-bootstrap/Pagination';

/**
 * 
 * @param {{pages: int, step: int, setStep: function}} props 
 * @returns 
 */
export default function CustomPagination(props) {

  const { step, pages, setStep, fetchData, pagesToShow } = props;


  const nextStep = () => {
    if (step < pages) {
      setStep(step + 1);
      pageChange(step + 1);
      window.scrollTo(0, 0);
    }
  }

  const regressStep = () => {
    if (step > 1) {
      setStep(step - 1);
      pageChange(step - 1);
      window.scrollTo(0, 0);
    }
  }

  const firstStep = () => {
    pageChange(1);
    window.scrollTo(0, 0);
  }

  const lastStep = () => {
    pageChange(pages);
    window.scrollTo(0, 0); 
  }

  const pageChange = (value) => {
    setStep(value);
    fetchData(value);
    window.scrollTo(0, 0);
  }

  const generatePagination = () => {
    let allSteps = [];
    
    const startPage = Math.max(1, step - Math.floor(pagesToShow / 2));
    const endPage = Math.min(pages, startPage + pagesToShow - 1);

    for (let i = startPage; i <= endPage; i++) {
      allSteps.push(
        <Pagination.Item 
          value={i}
          key={i} 
          active={i === step} 
          onClick={() => pageChange(i)}>
          {i}
        </Pagination.Item>
      )
    }

    return allSteps;
  }

  return (
    <Pagination className='justify-content-md-center'>
      <Pagination.First onClick={firstStep} />
      <Pagination.Prev onClick={regressStep} />

      {generatePagination()}

      <Pagination.Next onClick={nextStep} />
      <Pagination.Last onClick={lastStep} />
    </Pagination>
  );
}